import { Next, Pipe } from '../../../ui/features/pipeline-pattern/types';
import { Pipeline as GenericPipeline } from '../../../ui/features/pipeline-pattern/pipeline';

export class ErrorPipeline<TValue, TResult> extends GenericPipeline<TValue, TResult> {
    public constructor(
        pipes: ReadonlyArray<Pipe<TValue, TResult>>,
        terminal: Next<TValue, TResult>,
    ) {
        super(pipes, terminal);
    }
}
